import { OrganizationJsonLd } from "next-seo"

export const JsonLdOrganization = () => {
  const siteUrl = process.env.NEXT_PUBLIC_APP_URL

  return (
    <OrganizationJsonLd
      type="Organization"
      logo={`${siteUrl}/logo180.png`}
      legalName="Traqq Pty Ltd."
      name="Traqq"
      brand={{
        "@type": "Brand",
        name: "Traqq",
      }}
      foundingDate="2019"
      address={{
        streetAddress: "Level 10, 88 Phillip Street",
        addressLocality: "Sydney NSW 2000",
        addressRegion: "NSW",
        postalCode: "2000",
        addressCountry: "AU",
      }}
      contactPoint={[
        {
          contactType: "customer support",
          email: "support@traqq.com",
        },
      ]}
      sameAs={[
        "https://www.facebook.com/profile.php?id=100091955341253",
        "https://x.com/traqqapp?lang=en",
        "https://www.linkedin.com/company/traqq-time-tracking",
        "https://www.youtube.com/@traqqtimetracker",
        "https://www.capterra.com/p/230726/Traqq/",
        "https://www.crunchbase.com/organization/traqq",
        "https://www.getapp.com/project-management-planning-software/a/traqq/",
      ]}
      url={siteUrl}
    />
  )
}
